import { normalizeCreditConfig } from "../../utils/creditBranding";
const heroImage =
  "https://ik.imagekit.io/7khjnlfow/email-assets/thapar_logo.png?updatedAt=1776888126772";

export const defaultGuestRoomContent = {
  theme: {
    backgroundStyle: "resortWarm",
    primaryColor: "#9f1d2c",
    accentColor: "#12345a",
    headingFontStyle: "serif",
    bodyFontStyle: "sans",
    buttonRoundness: "pill",
  },
  home: {
    hero: {
      enabled: true,
      badge: "Institute Hospitality",
      title: "Welcome to Thapar Hostel Guest Rooms",
      subtitle:
        "Comfortable, secure and institute-managed accommodation for official guests, parents and visitors.",
      image: heroImage,
      slides: [{ title: "Welcome to Thapar Hostel Guest Rooms", subtitle: "Institute hospitality inside a secure campus.", image: heroImage }],
      primaryButton: "Book Your Stay",
      primaryButtonLink: "/guest-room/booking",
      primaryButtonVisible: true,
      secondaryButton: "Explore Rooms",
      secondaryButtonLink: "/guest-room/rooms",
      secondaryButtonVisible: true,
      overlayOpacity: 0.46,
    },
    sections: {
      intro: { enabled: true, eyebrow: "Welcome", heading: "Hospitality Inside the Thapar Campus", description: "" },
      featuredRooms: { enabled: true, eyebrow: "Featured Rooms", heading: "", description: "" },
      journey: { enabled: true, eyebrow: "Your Stay Journey", heading: "", description: "" },
      facilities: { enabled: true, eyebrow: "Facilities", heading: "Supported by campus hospitality services", description: "" },
      gallery: { enabled: true, eyebrow: "Camera Roll", heading: "A glimpse of Thapar hospitality", description: "" },
      cta: { enabled: true, eyebrow: "", heading: "", description: "" },
    },
    intro: {
      title: "Hospitality Inside the Thapar Campus",
      text:
        "Hostel Guest Rooms provide safe, comfortable and institute-managed accommodation for parents, official guests, faculty visitors and approved institutional guests.",
      image: "",
    },
    stats: [
      { label: "Guest Rooms", value: "31", icon: "rooms" },
      { label: "Campus Support", value: "24x7", icon: "support" },
      { label: "Secure Campus Stay", value: "Safe", icon: "security" },
      { label: "Booking Request", value: "Online", icon: "booking" },
    ],
    roomCards: [
      { title: "Campus Guest Room", hostel: "Institute Hostels", capacity: "1-2 Guests", description: "Calm rooms for approved short stays.", amenities: ["WiFi", "Housekeeping", "Support"], image: "", enabled: true },
      { title: "AC Guest Room", hostel: "Selected Hostels", capacity: "2 Guests", description: "Comfortable AC rooms subject to availability.", amenities: ["AC", "Hot water", "Online payment"], image: "", enabled: true },
      { title: "Family Visitor Stay", hostel: "Subject to availability", capacity: "Parents / Guardians", description: "Managed accommodation for approved visitors.", amenities: ["Secure campus", "Digital support"], image: "", enabled: true },
    ],
    journey: [
      { title: "Submit Enquiry", description: "Share visit and stay details.", icon: "send", image: "", enabled: true, order: 1, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Request Reviewed", description: "Hostel administration reviews availability.", icon: "review", image: "", enabled: true, order: 2, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Room Approved", description: "Approval and reporting instructions are sent.", icon: "approve", image: "", enabled: true, order: 3, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Report to Hostel", description: "Guest reports with valid ID proof.", icon: "hostel", image: "", enabled: true, order: 4, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Check-in & Payment", description: "Payment and check-in formalities are completed.", icon: "payment", image: "", enabled: true, order: 5, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Stay Support", description: "Caretaker and digital support remain available.", icon: "support", image: "", enabled: true, order: 6, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
      { title: "Checkout & Feedback", description: "Checkout is recorded and feedback can be submitted.", icon: "feedback", image: "", enabled: true, order: 7, backgroundColor: "", cardWidth: "", cardHeight: "", buttonText: "", buttonUrl: "" },
    ],
    facilities: ["WiFi", "Hot & Cold Water", "Housekeeping", "Medical Support", "Dining", "Online Payments", "Guest Support QR", "SOS Support"],
    cameraRoll: {
      enabled: true,
      speed: 32,
      images: [
        { image: heroImage, caption: "Thapar Institute" },
        { image: heroImage, caption: "Campus Guest Hospitality" },
        { image: heroImage, caption: "Institute Managed Stay" },
      ],
    },
    cta: {
      enabled: true,
      heading: "Ready to request accommodation?",
      text: "Submit your guest room request for review by hostel administration.",
      buttonLabel: "Book Now",
      buttonLink: "/guest-room/booking",
    },
    notice:
      "Cash payment is not accepted. Payments are non-refundable. Booking requests are subject to hostel administration approval.",
  },
  about: {
    hero: { title: "About Hostel Guest Rooms", subtitle: "Institute-managed visitor accommodation inside TIET campus.", image: "" },
    sectionSettings: {
      about: { enabled: true, eyebrow: "About", heading: "", description: "" },
      whyChooseUs: { enabled: true, eyebrow: "Why Choose Us", heading: "A thoughtful campus hospitality experience", description: "" },
      mission: { enabled: true, eyebrow: "Mission", heading: "", description: "" },
    },
    sections: [
      { title: "About Guest Rooms", text: "Thapar Hostel Guest Rooms are managed for institute-approved visitors, parents, guests and official invitees requiring short stay accommodation inside the campus.", image: "" },
      { title: "About Office of Student Affairs", text: "The Office of Dean Student Affairs coordinates hostel services, guest accommodation workflows and student welfare support.", image: "" },
    ],
    cards: ["Campus Security", "Managed by Institute", "Easy Approval Workflow", "Hostel-Based Support", "Digital Guest Services"],
    missionEyebrow: "",
    mission: "",
    vision: "",
    timeline: [],
  },
  rooms: {
    hero: { enabled: true, badge: "Rooms", title: "Comfortable Rooms Inside Campus", subtitle: "Room allotment is subject to approval and availability.", image: "" },
    sections: {
      categories: { enabled: true, eyebrow: "Room Categories", heading: "Select a hostel below to explore its guest rooms.", description: "" },
      notes: { enabled: true, eyebrow: "Before Requesting Accommodation", heading: "", description: "" },
    },
    categories: [],
    cards: [
      { title: "Single Occupancy", category: "Standard", capacity: "1 Guest", description: "Compact rooms for approved short stay guests.", amenities: ["WiFi", "Bed", "Study table"], image: "", enabled: true },
      { title: "Double Occupancy", category: "Standard", capacity: "2 Guests", description: "Comfortable stay for parents and approved visitors.", amenities: ["Two beds", "Washroom", "Support"], image: "", enabled: true },
      { title: "AC Rooms", category: "AC", capacity: "1-2 Guests", description: "Air-conditioned rooms subject to hostel availability.", amenities: ["AC", "WiFi", "Hot water"], image: "", enabled: true },
      { title: "Non-AC Rooms", category: "Non-AC", capacity: "1-2 Guests", description: "Standard campus guest accommodation.", amenities: ["Fan", "Clean linen", "Support"], image: "", enabled: true },
    ],
    notes: ["Availability subject to approval", "Room allotment depends on availability", "Room capacity rules apply", "Guest must carry valid ID/address proof"],
  },
  tariff: {
    hero: { title: "Tariff & Payment Information", subtitle: "Transparent tariff and payment rules for guest accommodation.", image: "" },
    sections: {
      tariff: { enabled: true, eyebrow: "Tariff", heading: "Payment Information", description: "" },
      rules: { enabled: true, eyebrow: "Important Rules", heading: "", description: "" },
      bankDetails: { enabled: true, eyebrow: "Bank Details", heading: "Official Payment Account", description: "" },
    },
    categoryLabel: "Category",
    tariffValueLabel: "Tariff for Stay",
    rows: [
      ["Thapar Students / Parents", "Rs. 850 per day"],
      ["Thapar Department Guest", "As approved / department pay"],
      ["External / Other Guests", "Rs. 1000 per day"],
      ["Official / Free Stay", "Subject to DoSA approval"],
    ],
    terms: ["Minimum one day charge is applicable after check-in.", "Even short stay after check-in is counted as one day.", "Payments are non-refundable.", "Early checkout does not create refund entitlement.", "Pending payment after checkout may mark guest as defaulter."],
    noCashPolicy: "Cash payment is not accepted for hostel guest room accommodation.",
    refundPolicy: "No refund after payment.",
    cancellationPolicy: "If guest does not report within 23 hours, booking may be auto-cancelled.",
    paymentInstructions: "Please make payment only after approval / check-in instruction.",
  },
  dining: {
    hero: { title: "Dining & Campus Food Facilities", subtitle: "Campus dining options for approved guests.", image: "" },
    sections: {
      hostelFood: { enabled: true, eyebrow: "Hostel Food Facilities", heading: "", description: "Guests may avail hostel mess/dining facilities as per applicable hostel rules and availability. Guest may directly pay the food charges at the hostel Food Counter." },
      campusFood: { enabled: true, eyebrow: "Campus Food Facilities", heading: "", description: "" },
      rules: { enabled: true, eyebrow: "Rules & Options", heading: "Dining guidance", description: "" },
    },
    text: "Guests may avail hostel mess/dining facilities as per applicable hostel rules and availability.",
    cards: [
      { title: "TIET Hostels Food Facilities", group: "hostel", timing: "As per hostel mess schedule", price: "As applicable", description: "Hostel food facilities are available subject to hostel mess rules and approval.", image: "", enabled: true, order: 1 },
      { title: "Campus Food Facilities", group: "campus", timing: "As per campus schedule", price: "As applicable", description: "Guests may avail campus food facilities as per applicable rules and availability.", image: "", enabled: true, order: 1 },
    ],
    rules: ["Meal availability is subject to hostel mess rules.", "Timings must be followed.", "Payment, if applicable, must follow institute policy."],
    options: ["Canteen", "Food Court", "Nescafe kiosk", "Campus cafes"],
  },
  facilities: {
    hero: { enabled: true, badge: "Facilities", title: "Facilities & Guest Support", subtitle: "Safe stay with digital support services.", image: "" },
    sections: {
      facilities: { enabled: true, eyebrow: "Facilities", heading: "", description: "" },
      digitalServices: {
        enabled: true,
        eyebrow: "Digital Services",
        heading: "Support from your mobile phone",
        description: "A QR code is available in every guest room. Scan it to raise a service request if you require any assistance.",
      },
      safety: { enabled: true, eyebrow: "Safety", heading: "Supervised campus support", description: "" },
    },
    facilities: ["31 Elegantly appointed non-smoking rooms", "24 hrs support", "Elevator", "Running hot & cold water", "Treated and purified drinking water", "Round-the-clock Health Centre", "Free WiFi", "Daily housekeeping", "Canteen, food court and Nescafe kiosks", "No cash policy", "Online payment support", "Digital guest support"],
    digitalServices: ["Cleaning Request", "Maintenance Request", "Medical Emergency", "SOS Alert", "Feedback"],
    safetyCards: ["Hostel caretaker support", "Warden supervision", "Office of Student Affairs support", "Health Centre support"],
  },
  gallery: {
    hero: { enabled: true, badge: "Gallery", title: "Gallery", subtitle: "Guest rooms, dining, hostel and campus views.", image: "" },
    sections: {
      gallery: { enabled: true, eyebrow: "Gallery", heading: "Campus guest room views", description: "" },
    },
    allCategoryLabel: "All",
    images: [],
    categories: ["Guest Rooms", "Dining", "Hostels", "Campus", "Facilities"],
  },
  booking: {
    hero: { title: "Request Hostel Guest Room Accommodation", subtitle: "Submit your guest room enquiry for review by hostel administration.", image: "" },
    sections: {
      form: { enabled: true, eyebrow: "Request Accommodation", heading: "Submit a guest room enquiry", description: "" },
      policies: { enabled: true, eyebrow: "Policies", heading: "Before submitting", description: "" },
    },
    enableParentStudentForm: true,
    enableFacultyStaffForm: true,
    lockParentStudentForm: false,
    parentStudentLockMessage: "Online booking is currently unavailable. Please contact the Hostel Office.",
    lockFacultyStaffForm: false,
    facultyStaffLockMessage: "Online booking is currently unavailable. Please contact the Hostel Office.",
    studentCard: { title: "Parents / Students", text: "Students may request guest accommodation for parents, guardians or immediate family members through the approval process." },
    staffCard: { title: "Faculty / Staff", text: "Faculty and staff guests can submit official guest accommodation requests using the form." },
    policies: ["Address proof mandatory", "Maximum request duration as per system settings", "Approval required", "Report within 23 hours after approval", "Payment is non-refundable", "No cash policy", "Room capacity rules apply", "Hostel rules must be followed"],
    termsText: "I confirm that the details are correct and I agree to the hostel guest room policies.",
    successMessage: "Your guest room booking request has been submitted successfully. You will receive an email update after review.",
    instructionText: "Please submit the request only after confirming visit dates and guest details.",
  },
  contact: {
    hero: { title: "Contact Us", subtitle: "Hostel Guest Room support and institute contact details.", image: "" },
    sections: {
      contact: { enabled: true, eyebrow: "Contact", heading: "", description: "" },
      emergency: { enabled: true, eyebrow: "Emergency", heading: "Support contacts", description: "" },
    },
    location: "Thapar Institute of Engineering & Technology, Patiala, Punjab",
    office: "Office of Dean Student Affairs",
    dosaOfficeAddress: "Office of Student Affairs, TIET Patiala",
    emails: ["dosa.office@thapar.edu", "hostel.support@thapar.edu", "itmh@thapar.edu"],
    phones: [],
    hours: "9:00 AM to 5:30 PM, Monday to Friday",
    assistanceText: "For any further assistance, contact the Office of Student Affairs.",
    mapUrl: "https://www.google.com/maps?q=Thapar+Institute+of+Engineering+and+Technology+Patiala&output=embed",
    feedbackLink: "/guest-feedback",
    emergencyContacts: [],
  },
  footer: {
    logo: heroImage,
    title: "Hostel Guest Room Booking System",
    subtitle: "Thapar Institute of Engineering & Technology",
    description: "Official public portal for hostel guest room accommodation requests at Thapar Institute of Engineering & Technology.",
    mapUrl: "https://www.google.com/maps?q=Thapar+Institute+of+Engineering+and+Technology+Patiala&output=embed",
    copyrightText: "© 2026 TIET",
    maintainedText: "Created and Maintained by Office of Student Affairs",
    quickContact: "Office of Dean Student Affairs",
    quickLinks: [
      { label: "Home", href: "/guest-room" },
      { label: "Rooms", href: "/guest-room/rooms" },
      { label: "Tariff", href: "/guest-room/tariff" },
      { label: "Facilities", href: "/guest-room/facilities" },
      { label: "Booking", href: "/guest-room/booking" },
      { label: "Contact", href: "/guest-room/contact" },
      { label: "Policies", href: "/policies" },
      { label: "Terms", href: "/terms" },
    ],
    socialLinks: {
      instagram: "",
      snapchat: "",
      twitter: "",
      facebook: "",
      youtube: "",
    },
  },
  quicklinks: { links: [] },
  bankdetails: {
    accountName: "",
    accountNumber: "",
    ifsc: "",
    bankName: "",
    branch: "",
    instructions: "Please make payment only after approval / check-in instruction.",
  },
};

const isPlainObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value);

const mergeContentValue = (base, override) => {
  if (override === undefined || override === null) return base;
  if (!isPlainObject(base) || !isPlainObject(override)) return override;
  const next = { ...base };
  Object.keys(override).forEach((key) => {
    next[key] = mergeContentValue(base?.[key], override[key]);
  });
  return next;
};

export const mergeGuestRoomContent = (remote = {}) => mergeContentValue(defaultGuestRoomContent, normalizeCreditConfig(remote));

export const WEBSITE_SECTION_TABS = [
  ["home", "Home"],
  ["about", "About"],
  ["rooms", "Rooms"],
  ["tariff", "Tariff"],
  ["dining", "Dining"],
  ["facilities", "Facilities"],
  ["gallery", "Gallery"],
  ["booking", "Booking"],
  ["contact", "Contact"],
  ["footer", "Footer"],
  ["quicklinks", "Quick Links"],
  ["bankdetails", "Bank Details"],
  ["theme", "Theme"],
];
